import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { PlanComparison } from '../PlanDescriptionCards/PlanComparison';
import { CompliancePackageData } from '../../types/compliance';
import { CurrentPlanDetails } from '../../types/plan';

export interface UpgradeToAdvancedStepContentProps {
    compliancePackageData: CompliancePackageData;
    currentPlan: CurrentPlanDetails;
    isUsSeller?: boolean;
}

export const UpgradeToAdvancedStepContent = ({
    compliancePackageData,
    currentPlan,
    isUsSeller,
}: UpgradeToAdvancedStepContentProps) => (
    <Stack direction="column" width="fit-content" paddingX="10" paddingTop="2" overflow="auto">
        <PlanComparison
            compliancePackageData={compliancePackageData}
            currentPlan={currentPlan}
            isUsSeller={isUsSeller}
        />
    </Stack>
);
